<template>
    <div v-show="show">
        <div @click="hide()" class="bg-effect"></div>
        <div class="validation-popup">
            <p class="validation-text">{{text}}</p>
            <base-button @click.native="hide()" background="var(--green-2-color)" padding="8px 16px">ОК</base-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "validation-popup",
        data() {
            return {
                show: false
            }
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            text: {
                type: String,
                default: ""
            }
        },
        mounted() {
            this.show = this.value
        },
        methods: {
            hide() {
                this.show = false
            }
        },
        watch: {
            value(val) {
                this.show = val
            },
            show(val) {
                this.$emit("input", val)
            },
        }
    }
</script>

<style scoped>
    .validation-popup {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        background-color: var(--white-color);
        padding: 18px 24px;
        display: grid;
        grid-template-columns: 1fr auto;
        align-items: center;
        grid-gap: 34px;
        box-shadow: 0px 1px 20px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        z-index: 100;
    }
    .validation-popup .validation-text{
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;
        color: #727272;
    }
    .bg-effect{
        z-index: 99;
    }
</style>
